export default __webpack_public_path__ + "static/magic-eden-68eb356123df98be7e63c8fe06b4e71a.svg";